import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation } from 'react-query';

import { crmModels } from '..';

export const useLeadForceAttachDefaultCreate = () =>
  useMutation(async ({ houseId, ...data }: crmModels.ILeadForceAttachDefaultCreate & { houseId?: number | null }) => {
    const res = await $api.post(
      stringifyUrl({
        url: '/v1/lead/force-attach/default-create',
        query: { houseId }
      }),
      data
    );

    return res?.data;
  });
